import { render, staticRenderFns } from "./FormTableSkus.vue?vue&type=template&id=2ec8a528&scoped=true"
import script from "./FormTableSkus.vue?vue&type=script&lang=js"
export * from "./FormTableSkus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec8a528",
  null
  
)

export default component.exports